import moment from "moment";

export function formatDate(date: string): string {
	const isTodayOrYesterday = moment().isSame(date, "day") || moment().subtract(1, "days").isSame(date, "day");
	return moment(date).format(isTodayOrYesterday ? "dddd" : "MMM DD");
}

type PrivateNote = {
	linkedNote: {
		eventStart: string | null;
		createdAt: string | null;
	} | null;
};

export function sortByLinkedNote(a: PrivateNote, b: PrivateNote) {
	if (!b.linkedNote?.eventStart && !b.linkedNote?.createdAt) return -1;
	if (!a.linkedNote?.eventStart && !a.linkedNote?.createdAt) return 1;
	const aDate = a.linkedNote.eventStart || a.linkedNote.createdAt || "";
	const bDate = b.linkedNote.eventStart || b.linkedNote.createdAt || "";
	return aDate > bDate ? -1 : 1;
}
